export const learnMoreUrl =
    'https://support.approvalmax.com/portal/en/kb/approvalmax-1/approvalmax-for-xero/budget-checking';

export const sourceFileIdName = 'sourceFileId';
export const sourceFilesField = 'sourceFiles';
